import './auxiliary-message-component.scss';
import { AuxiliaryMessage, Button, TableState } from '../../slices/tableSlice';
import { SharkBidComponent } from '../shark-bid-component/shark-bid-component';
import { bridgeWarGui } from '../../env';
import { classNames, handleGlossaryAndQuizActions, handleGlossaryMouseOut } from '../../utils/mixed';
import { insertSuits } from '../../utils/shark-helper';
import { outputActions } from '../../slices/outputSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import React from 'react';

export const AuxiliaryMessageComponent: React.FC<{ position: keyof TableState['auxiliaryMessages'] }> = ({
    position,
}) => {
    const { auxiliaryMessages } = useAppSelector((state) => state.table);
    const dispatch = useAppDispatch();
    const message = auxiliaryMessages[position];
    const { output_setWalkThruTarget } = outputActions;

    const buttons: [
        AuxiliaryMessage['buttonAuxiliary'] | AuxiliaryMessage['buttonOk'] | AuxiliaryMessage['buttonCancel'],
        Button['id'],
    ][] = [
        [message?.buttonAuxiliary, 'auxiliaryAuxiliary'],
        [message?.buttonOk, 'auxiliaryOk'],
        [message?.buttonCancel, 'auxiliaryCancel'],
    ];

    const hasButtons = message?.buttonCancel || message?.buttonOk || message?.buttonAuxiliary;
    const { sharkLayout } = useAppSelector((state) => state.app);
    const { selectedCardSet } = sharkLayout;
    return (
        <section
            className={classNames(
                'AuxiliaryMessageComponent',
                position,
                message?.bid && 'bidExplanation',
                hasButtons && 'hasButtons',
                message?.bottom && 'bottom',
                bridgeWarGui && 'isBridgeWar',
            )}
        >
            {message?.title && !message?.bid && (
                <div
                    className="title"
                    style={{ color: message.titleColor }}
                    dangerouslySetInnerHTML={{ __html: message.title }}
                />
            )}
            {!message?.title && message?.bid && (
                <header>
                    <SharkBidComponent bid={message?.bid} selectedCardSet={selectedCardSet} />
                </header>
            )}

            {message?.title && message?.bid && (
                <header>
                    <SharkBidComponent bid={message?.bid} selectedCardSet={selectedCardSet} alert={message.title}/>
                </header>
            )}

            {message?.text && (
                <div
                    className="text"
                    dangerouslySetInnerHTML={{ __html: insertSuits(message.text) }}
                    onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                    }}
                    onTouchStart={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        dispatch(output_setWalkThruTarget(handleGlossaryAndQuizActions(event, true)));
                    }}
                    onMouseDown={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        dispatch(output_setWalkThruTarget(handleGlossaryAndQuizActions(event, true)));
                    }}
                    onMouseOver={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        dispatch(output_setWalkThruTarget(handleGlossaryAndQuizActions(event, false)));
                    }}
                    onMouseOut={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        dispatch(output_setWalkThruTarget(handleGlossaryMouseOut(event)));
                        //Close the tool tip
                    }}
                />
            )}
            {hasButtons && (
                <div className="buttons">
                    {buttons.map(([label, id]) => {
                        return (
                            label &&
                            id && (
                                <button
                                    key={id}
                                    onClick={() =>
                                        dispatch(
                                            outputActions.output_setButton({
                                                id,
                                                value: message?.value ? [message?.value, position] : position,
                                            }),
                                        )
                                    }
                                >
                                    {label}
                                </button>
                            )
                        );
                    })}
                </div>
            )}
        </section>
    );
};
